import { ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";
import { Collapse as MuiCollapse, IconButton } from "@mui/material";

import React, { useEffect, useState } from "react";

const Collapse = (props) => {
  const { title, show, children } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(show);
    return () => {};
  }, [show]);

  const handleExpand = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <div className="bg-white shadow rounded-2xl">
        <div
          onClick={handleExpand}
          className="flex items-center justify-between cursor-pointer hover:bg-gray-100 rounded-[10px] px-[10px] select-none p-[5px] m-[5px]"
        >
          <div>
            <span className="text-lg font-semibold text-gray-600 border-left uppercase">
              {title}
            </span>
          </div>
          <IconButton size="small">
            {open ? <ExpandLessRounded /> : <ExpandMoreRounded />}
          </IconButton>
        </div>

        <MuiCollapse in={open}>
          <>{children}</>
        </MuiCollapse>
      </div>
    </>
  );
};

export default Collapse;
